export default "__VITE_ASSET__HQlbQ32W__"